export default "__VITE_ASSET__001b4eba__"